import React from "react";

export const Arrow = (props) => {
	const project = props.project;
	const y = props.position;
	const Visible = props.Visible;
	return (
		<div className={`arrow ${project.archive ? "archive" : ""}  ${project ? "visible" : ""}`} style={props.position}>
			<svg viewBox="0 0 16.1 16" style={!Visible ? { display: "none" } : null}>
				<g id="base">
					<path d="M15.3,7H0l0,2h15.3V7z" />
				</g>
				<g id="fin">
					<path d="M14.6,7h-3.1v2h3.1V7z" />
				</g>
				<g id="down">
					<path d="M13.6,8H16c0,0.3-0.1,0.5-0.3,0.7l-6.4,6.4c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4L13.6,8z" />
				</g>
				<g id="top">
					<path d="M13.6,8H16c0-0.3-0.1-0.5-0.3-0.7L9.4,0.9C9,0.5,8.4,0.5,8,0.9C7.6,1.3,7.6,2,8,2.3L13.6,8z" />
				</g>
			</svg>
		</div>
	);
};
